<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> 分组列表</h3>
      <div class="box-tools">
        <el-button size="small" class="pull-right" type="primary" @click="toEditGroup()" round><i class="fa fa-plus"></i> 添加分組</el-button>
      </div>
    </div>
    <div class="box-body">
      <el-table
          class="list-table"
          ref="multipleTable"
          :data="groupList"
          border
          tooltip-effect="dark"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="120"></el-table-column>
        <el-table-column prop="type" label="类型" width="240" :formatter="formatType"></el-table-column>
        <el-table-column prop="isDefault" label="是否默认分组" min-width="240" :formatter="formatDefault"></el-table-column>
        <el-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click.prevent="toEditGroup(scope.row)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button @click.prevent="deleteGroup(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页-->
    <page-bar v-model="page" @change="fetchData"></page-bar>

    <el-dialog :title="curGroup ? '编辑' : '添加'" :visible.sync="dialogVisible" :destroy-on-close="true" width="720px" class="form-dialog">
      <el-form :model="groupForm" :rules="rules" ref="groupForm" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="groupForm.name" placeholder="输入分组名称" style="width: 50%"></el-input>
        </el-form-item>
        <el-row>
          <el-col span="12">
            <el-form-item label="类别" prop="type">
              <el-radio-group v-model="groupForm.type">
                <el-radio :label="0">用户组</el-radio>
                <el-radio :label="1">组织机构组</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="默认">
              <el-radio-group v-model="groupForm.isDefault">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="选择用户" v-show="groupForm.type === 0" prop="relationIds">
          <template>
            <el-select v-model="groupForm.relationIds" multiple filterable placeholder="请输入姓氏进行模糊搜索" style="width: 50%">
              <el-option v-for="item in options" :key="item.value" :label="item.trueName" :value="item.id"></el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="选择机构" v-show="groupForm.type === 1" prop="relationIds">
          <el-transfer v-model="groupForm.relationIds" :props="props" :data="unitTree" :titles="['机构名称', '已选机构']"></el-transfer>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false"><i class="fa fa-close"></i> 取 消</el-button>
        <el-button type="primary" @click="saveGroup"><i class="fa fa-save"></i> 确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, get, remove, save, update } from '@/api/system/group'
import PageBar from '@components/PageBar'
import { handleConfirm } from '@utils/confirm'
import { fetchList as fetchUnit } from '@/api/system/unit'
import { findAll } from '@api/system/user'

export default {
  created() {
    this.fetchData()
  },
  components: { PageBar },
  methods: {
    fetchData() {
      fetchList({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        query: this.page.param
      }).then(resp => {
        let data = resp.data.result
        this.$set(this.page, 'total', data.total)
        this.$set(this.page, 'pageNo', data.pageNo)
        this.$set(this.page, 'pageSize', data.pageSize)
        this.groupList = data.records
      })
    },
    formatType: function(row, column, val) {
      if (val === 0) {
        return '用户组'
      }
      if (val === 1) {
        return '组织机构'
      }
    },
    formatDefault: function(row, column, val) {
      if (val === 1) {
        return '是'
      }
      if (val === 0) {
        return '否'
      }
    },
    toEditGroup(val) {
      this.curGroup = val
      this.dialogVisible = true

      this.userData()
      this.unitTransfer()

      if(!this.curGroup){
        this.groupForm = {
          isDefault: 1,
          type: 0,
          relationIds: []
        }
      }else{
        this.getGroup()
      }
    },
    deleteGroup(val) {
      handleConfirm('此操作将永久删除该角色, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
    },
    unitTransfer() {
      fetchUnit().then(resp => {
        resp.data.result.forEach(row => {
          let prefix = []
          if (row.parentIds && row.parentIds !== '0') {
            let preLength = row.parentIds.split(',').length
            prefix = Array(preLength === 0 ? 1 : preLength).fill('　')
          }
          row.name = prefix.join('') + '├ ' + row.name
        })
        this.unitTree = resp.data.result
      })
    },
    userData() {
      findAll().then(resp => {
        this.options = resp.data.result
      })
    },
    getGroup() {
      get(this.curGroup.id).then(resp => {
        this.groupForm = resp.data.result
      })
    },
    saveGroup() {
      this.$refs['groupForm'].validate(valid => {
        if (valid) {
          if (this.curGroup) {
            update(this.groupForm).then(resp => {
              this.submitCallback(resp)
            })
          } else {
            save(this.groupForm).then(resp => {
              this.submitCallback(resp)
            })
          }
        }
      })
    },
    submitCallback(resp) {
      if (resp.status === 200) {
        this.$message.success(resp.data.message)
        this.dialogVisible = false
        this.fetchData()
      }
    }
  },
  data() {
    return {
      page: {
        pageSize: 20,
        pageNo: 1
      },
      groupList: [],
      dialogVisible: false,
      curGroup:null,
      options: [],
      relationIds: [],
      unitTree: [],
      props: {
        key: 'id',
        label: 'name'
      },
      groupForm: {
        name: '',
        isDefault: 1,
        type: 0,
        relationIds: []
      },
      rules: {
        name: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        type: [{ required: true, message: '请选择分组所在用户', trigger: 'change' }]
      },
      radio: ''
    }
  }
}
</script>

